<template>
    <div class="tw-px-8 tw-py-2">
        <Table
            :columns="columns"
            :data="row.accounts || []"
            size="small"
            :no-data-text="$t('bankProfile.noAccounts')"
        ></Table>
    </div>
</template>

<script>
export default {
    name: "BankProfileTableExpand",
    props: {
        row: { type: Object, required: true }
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t("bankProfile.accountNo"),
                    key: "account_no",
                    minWidth: 160
                },
                {
                    title: this.$t("bankProfile.accountName"),
                    key: "account_name",
                    minWidth: 200
                }
            ];
        }
    }
};
</script>
